// what the heck
export const wording = {
    progress: "進度",
    confidence: "信心",
    targetRatio: "任務期限",
}
